import styled from 'styled-components';

const Container = styled.div`
    position: relative;
    display: block;
    width: auto;
    height: auto;
`;

export default Container;
